<i18n src='@/locale/person-localization.json'></i18n>

<template>
    <v-container >
        <v-data-table
            dense
            :headers="headers"
            :options.sync="options"
            :items="gridData"
            :server-items-length="gridDataTotalCount"
            class="elevation-1 row-pointer"
            :footer-props="footerProps"
            @click:row="$emit('clickedOnRow',$event)"
            @contextmenu:row="show"
        >
            <template v-slot:header.actions="{ header }">
                <v-btn color="primary" fab small depressed @click="Add">
                    <v-icon>mdi-plus</v-icon>
                </v-btn>
            </template>
            <template v-slot:item.DateTimeFrom="{ item }">
                {{ FormatDate(item.DateTimeFrom) }}
            </template>
            <template v-slot:item.DateTimeTill="{ item }">
                {{ FormatDate(item.DateTimeTill) }}
            </template>
        </v-data-table>
        <v-menu
            v-model="showMenu"
            :position-x="x"
            :position-y="y"
            absolute
            offset-y
        >
            <v-btn
                @click="EditItem"
            >
                <v-icon>mdi-square-edit-outline</v-icon>
                {{ $t('Edit') }} 
            </v-btn>
        </v-menu>
        <v-wm-form-dialog 
            v-model="dialog"
            max-width="1300px"
            :hide-title="true"
            :hide-actions="true"
        >
            <diagnosis-form-component
                :historyCode='personHistoryCode'
                :formTitle="$t('Add')"
                :diagnosisData="diagnosisData"
                @Cancel="closeDialog"
                @updated="diagnosisUpdated"
            >
                <template v-slot:headerCenter>
                    {{ personFullName }}
                </template>
            </diagnosis-form-component>
        </v-wm-form-dialog>
    </v-container>
</template>

<script>
import VWmCreateEditDialog from '@/component/nosology/create-edit-dialog.vue';
import {getDateStr,getTimeStr} from '@/script/common';
import patientDiagnosisService from "@/service/patient-diagnosis-service";
import VWmFormDialog from '@/component/form-dialog2.vue';
import diagnosisFormComponent from '../diagnosis-form-component.vue';
import diagnosisService from "@/service/diagnosis-service";

export default {
    components: {
        VWmCreateEditDialog,
        VWmFormDialog,
        diagnosisFormComponent
    },
    props: ["personHistoryCode","personFullName"],
    created() {
        this.ReloadGrid()
    },
    data() {
        return {
            footerProps: {
                itemsPerPageOptions: [10, 25, 50, 100],
                showFirstLastPage: true,
                firstIcon: 'first_page',
                lastIcon: 'last_page',
                prevIcon: 'navigate_before',
                nextIcon: 'navigate_next',
            },
            headers: [
                {
                    text: this.$t('N'),
                    value: 'NumberString',
                    sortable: false,
                },
                { text: this.$t('Open'), value: 'DateTimeFrom', sortable: false },
                { text: this.$t('Close'), value: 'DateTimeTill', sortable: false },
                { text: this.$t('kod'), value: 'kod', sortable: false },
                { text: this.$t('Name'), value: 'Name', sortable: false },
                { text: '', value: 'actions', sortable: false },
            ],
            gridData: [],
            gridDataTotalCount: 0,
            options: {
                page: 1,
                itemsPerPage: 10,
            },
            lastSearch: null,
            showMenu: false,
            x: 0,
            y: 0,
            dialog: false,
            diagnosisNumber: null,
            diagnosisData: {}
        };
    },

    watch: {
        'options.page'() {
            this.ReloadGrid();
        },
        'options.itemsPerPage'() {
            this.ReloadGrid();
        }
    },

    methods: {
        OnSearch() {
            // if (this.lastSearch !== this.filter.search) {
            if (this.options.page === 1) {
                this.ReloadGrid();
            } else {
                this.options.page = 1;
            }
            // }
        },
        ReloadGrid() {
            const { sortBy, sortDesc, page, itemsPerPage } = this.options;
            // this.lastSearch = this.filter;
            patientDiagnosisService
                .getData(page, itemsPerPage, {HistoryCode: this.personHistoryCode})
                .then((data) => {
                    this.gridData = data.data;
                    // შესაცვლელია data.total-ით
                    this.gridDataTotalCount = data.data.length;
                });
        },
        FormatDate(date) {
            return date ? getDateStr(date) + ' ' + getTimeStr(date) : '';
        },
        show(e, item) {
            this.diagnosisNumber = item.item.Number
            e.preventDefault()
            this.showMenu = false
            this.x = e.clientX
            this.y = e.clientY
            this.$nextTick(() => {
                this.showMenu = true
            })
        },
        getDiagnosis(number) {
            diagnosisService
                .get({
                    historyCode: this.personHistoryCode,
                    number: number,
                })
                .then((data) => {
                    this.diagnosisData = data
                });
        },
        Add() {
            this.dialog = true;
        },
        EditItem() {
            this.getDiagnosis(this.diagnosisNumber)
            this.dialog = true;
        },
        closeDialog() {
            this.dialog = false;
        },
        diagnosisUpdated() {
            this.dialog = false;
            this.ReloadGrid();
        }
    },
};
</script>

<style>
.row-pointer > .v-data-table__wrapper > table > tbody > tr:hover {
    cursor: pointer;
}
</style>
